import { c as _c } from "react/compiler-runtime";
import { Box, Icon } from '@petsmart-ui/sparky';
import { FREE_SHIPPING_THRESHOLD_US_CA } from '../../constants/freeShipping';
import { CountdownBar } from './CountdownBar';
import { CountdownHelper } from './CountdownHelper';
import { CountdownTitle } from './CountdownTitle';
import './CountdownMeter.scss';
export type CountdownCardProps = {
  readonly qualifyingSubtotal: number;
  readonly isLoggedIn: boolean;
};
export const CountdownCard = t0 => {
  const $ = _c(12);
  const {
    qualifyingSubtotal,
    isLoggedIn
  } = t0;
  const amountAway = Math.max(0, FREE_SHIPPING_THRESHOLD_US_CA - qualifyingSubtotal);
  const progressTowardThreshold = Math.min(Math.max(0, qualifyingSubtotal), FREE_SHIPPING_THRESHOLD_US_CA);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon size="md" className="countdown-card__icon" name="box-outline" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== amountAway || $[2] !== isLoggedIn) {
    t2 = <div className="countdown-card__header">{t1}<CountdownTitle amountAway={amountAway} isLoggedIn={isLoggedIn} /></div>;
    $[1] = amountAway;
    $[2] = isLoggedIn;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== progressTowardThreshold) {
    t3 = <div className="sparky-u-margin-top-xs"><CountdownBar value={progressTowardThreshold} total={FREE_SHIPPING_THRESHOLD_US_CA} startLabel="$0" endLabel="$49" /></div>;
    $[4] = progressTowardThreshold;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isLoggedIn) {
    t4 = !isLoggedIn && <CountdownHelper />;
    $[6] = isLoggedIn;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <Box styleModifier="flush" className="countdown-card" data-testid="countdown-card"><div className="countdown-card__section">{t2}{t3}{t4}</div></Box>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};